import { Button, Flex, Input, message, Modal, Table, Typography, Select, Pagination, Spin } from "antd";
import React, { useState } from "react";

import { controller as rootController } from "../../../controller";
import close from "../../../assets/icons/close-circle.svg";
import { controller } from "../controller";

export default function PMSDataModal({
  setNewTreatmentProcedure,
  totalPmsTablePageSize,
  processTreatmentPlans,
  setSelectedRowKeys2,
  setIsModalVisible5,
  handleReadPmsData,
  selectedRowKeys2,
  isGettingPmsData,
  isModalVisible5,
  handleReadData2,
  setPmsTablePage,
  setPmsDataType,
  setDisableAdd,
  handleCancel4,
  pmsTablePage,
  selectModal,
  pmsDataType,
  setLoading,
  pmsColumns,
  setSearch,
  setNewKey,
  patientID,
  itemlist,
  optional,
  loading,
  search,
  pms,
}) {
  const [isSyncing, setIsSyncing] = useState(false);

  async function createTreatmentWithPMS() {
    const treatmentProcedureData = {};

    // treatmentProcedureData.insurance_estimate = expandedRowData && expandedRowData.insurance_estimate;
    treatmentProcedureData.discount = "0";

    if (selectedRowKeys2 && selectedRowKeys2.length > 0) {
      treatmentProcedureData.treatment_procedure_ids = selectedRowKeys2;
    }

    if (Object.keys(treatmentProcedureData).length > 0 || selectedRowKeys2.length > 0) {
      setLoading(true); // Set loading to true

      try {
        const dataToSend = {
          name: "Treatment Name",
          patient: localStorage.getItem("patient_id")
            ? localStorage.getItem("patient_id")
            : localStorage.getItem("modalSelectId")
              ? localStorage.getItem("modalSelectId")
              : localStorage.getItem("newPatientId"),
          optional,
        };
        let response;
        dataToSend.treatment_procedure_data = treatmentProcedureData;
        dataToSend.tooth_from = "Tooth Name";

        response = await controller.createTreatmentPlanAndProcedure(dataToSend);

        if (response.status < 250) {
          message.success("Treatment plan created successfully!");
          setIsModalVisible5(false);
        }

        processTreatmentPlans();
        setDisableAdd(false);
        handleReadData2();
        setNewKey(undefined);
        setSelectedRowKeys2([]);
        setNewTreatmentProcedure(false);
        processTreatmentPlans();
      } catch (error) {
        console.error("Error saving treatment plan:", error);
      } finally {
        setLoading(false); // Reset loading to false after completion
      }
    } else {
      console.error("No treatment procedure data or selectedRowKeys2 to send.");
    }
  }

  async function handleSyncData() {
    try {
      setIsSyncing(true);

      const response = await rootController.syncPMSDataModal(patientID);

      if (response.status < 250) {
        handleReadPmsData();
      }
    } catch (err) {
      message.error("Something went wrong while syncing data");
      console.error(err);
    } finally {
      setIsSyncing(false);
    }
  }

  let formatedLastUpdate;
  if (
    itemlist[0] &&
    itemlist[0].treatment_plans[0] &&
    itemlist[0].treatment_plans[0].treatment_procedures[0] &&
    itemlist[0].treatment_plans[0].treatment_procedures[0].last_update
  ) {
    formatedLastUpdate = new Date(itemlist[0].treatment_plans[0].treatment_procedures[0].last_update);

    // Example 1: Friendly format (e.g., for emails or UI)
    formatedLastUpdate = formatedLastUpdate.toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
      // timeZoneName: "short", // Optional: adds "UTC"
    });
  }

  return (
    <Modal
      title={
        selectModal ? (
          "Treatments Pulled from PMS"
        ) : (
          <Flex align="center" justify="space-between">
            <Typography.Title level={4}>PMS Data Preview</Typography.Title>

            <Flex align="center" gap={10}>
              <Typography.Paragraph style={{ marginBottom: 0, color: "#848696" }}>{formatedLastUpdate}</Typography.Paragraph>

              <Flex align="center" gap={10}>
                <Button type="primary" loading={isSyncing} style={{ width: 100 }} onClick={() => handleSyncData()}>
                  Sync
                </Button>
                <img src={close} alt="close-icon" style={{ cursor: "pointer" }} onClick={() => handleCancel4()} />
              </Flex>
            </Flex>
          </Flex>
        )
      }
      open={isModalVisible5}
      width={1400}
      style={{ maxWidth: "95vw", top: 20 }}
      footer={null}
      onCancel={() => handleCancel4()}
      closeIcon={null}
    >
      <>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", marginBottom: 16 }}>
          <p style={{ color: "#848696", marginBottom: 0 }}>You can select Procedures and add to selected Treatment.</p>

          <Select
            options={[
              { label: "Planned", value: "active" },
              { label: "Completed", value: "completed" },
            ]}
            defaultValue="active"
            placeholder="Select Treatment Type"
            className="treatment-filter-input"
            style={{ width: 130 }}
            onChange={(value) => setPmsDataType(value)}
            value={pmsDataType}
          />
        </div>
        <Input
          style={{ width: "100%", height: 43, borderRadius: 8, border: "1px solid #6B43B5", marginBottom: 30 }}
          placeholder="Search Procedures"
          value={search} // <-- Bind the input to `search`
          onChange={(e) => setSearch(e.target.value)}
        />

        <div>
          {isGettingPmsData ? (
            <divs style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
              <Spin />
            </divs>
          ) : (
            <>
              <Table
                columns={pmsColumns}
                dataSource={pms}
                rowKey="id" // Unique key for each row (assuming your data has a unique 'id' field)
                pagination={false}
                size="small"
                scroll={{ x: "450px" }}
                className="pms-tx-data-table"
                rowSelection={{
                  type: "checkbox", // Allow multi-row selection
                  selectedRowKeys: selectedRowKeys2,
                  onChange: (newSelectedRowKeys) => setSelectedRowKeys2(newSelectedRowKeys),
                }}
              />

              <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
                <Pagination
                  showSizeChanger={false}
                  current={pmsTablePage}
                  total={totalPmsTablePageSize}
                  onChange={(page) => setPmsTablePage(page)}
                  className="paginator"
                />
              </div>
            </>
          )}
        </div>

        <Button
          type="primary"
          loading={loading}
          style={{ marginTop: 20, width: "100%", height: 45, borderRadius: 50 }}
          // onClick={() => postExistingPro()}
          onClick={() => createTreatmentWithPMS()}
          disabled={(pms && pms.length === 0) || selectedRowKeys2.length === 0} // Disable if there is no data (pms) or no pms is selected
        >
          {selectModal ? "Add to Treatment" : "Add to Table"}
        </Button>
      </>
    </Modal>
  );
}
